// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25wTf","left":"styles_left__1kYAT"};